import {
    Component,
    Input
} from '@angular/core';
import { TableOfContentOrientationEnum } from '../../../../Monitor/Briefings/enums/table-of-content-orientation.enum';
import { BriefingHeadingLevelEnum } from '../../../../Monitor/Briefings/enums/briefing-heading-level.enum';
import { TableOfContentBlockDataModel } from '../../../../Monitor/Briefings/models/table-of-content-block-data.model';
import { BriefingBlockTypeApiEnum } from '../../../../api/briefings/enum/briefing-block-type-api.enum';
import { mediaTypeNoHeadlineMap } from '../../../Basic/enums/media-type.enum';

@Component({
    selector: 'agpr-table-of-contents-display',
    templateUrl: './table-of-contents-display.component.html',
    styleUrls: ['./table-of-contents-display.component.scss'],
    standalone: false,
})
export class TableOfContentsDisplayComponent {
    @Input() set data(data: any) {
        this._data = data;
        if (data?.settings) {
            this.orientation = data.settings.orientation;
            this.includeMentionCount = data.settings.includeMentionCount;
            this.includeMentionSections = data.settings._includeMentionSections;
            this.includeHeadlines = data.settings.includeHeadlines;
            this.includeTitle = data.settings.includeTitle;
            if (data.settings.titleLevel === BriefingHeadingLevelEnum.HEADING_1) {
                this.titleLevel = 1;
            } else if (data.settings.titleLevel === BriefingHeadingLevelEnum.HEADING_2) {
                this.titleLevel = 2;
            } else {
                this.titleLevel = 3;
            }
        }

        if (data.blocks?.length) {
            this.titleBlocks = data.blocks.filter(block => {
                return (
                    (this.includeTitle && (block.type === BriefingBlockTypeApiEnum.TITLE) && (block.titleLevel <= this.titleLevel)) ||
                        (block.type === BriefingBlockTypeApiEnum.CURATED_MENTION_LIST || block.type === BriefingBlockTypeApiEnum.AUTOMATIC_MENTION_LIST)
                );
            });
        } else {
            this.titleBlocks = [];
        }
    };

    readonly headingLevels = BriefingHeadingLevelEnum;
    readonly orientations = TableOfContentOrientationEnum;
    readonly blockTypes = BriefingBlockTypeApiEnum;
    readonly mediaTypeNoHeadlineMap = mediaTypeNoHeadlineMap;

    _data: any;
    orientation: TableOfContentOrientationEnum;
    includeMentionCount: boolean;
    includeMentionSections: boolean;
    includeHeadlines: boolean;
    includeTitle: boolean;
    titleLevel: number;
    titleBlocks: TableOfContentBlockDataModel[];

    constructor() {}

    scrollTo(blockId: string, mentionId?: string) {
        if (mentionId && document.getElementById(blockId+mentionId)) {
            document.getElementById(blockId+mentionId).scrollIntoView({ behavior: 'smooth' });
        } else {
            document.getElementById(blockId)?.scrollIntoView({ behavior: 'smooth' });
        }
    }
}
